module.exports = __webpack_public_path__ + "static/card-logo-dark-374a759c68711ed85d97d97cd30a405e.svg";